import React from 'react';
import loadable from '@loadable/component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../premium_page').default;
}

export default function(store) {
  const routeConfig = {
    path: `/premium/:page?`,
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'premium') : false,
    preloadChunk() {
      return import(/* webpackChunkName: "tagPage" */ '../premium_page').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store, 'premium');
          return Component;
        }
      );
    },
    chunk: 'tagPage'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="tag-page">
        <article className="tag-page__main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });
  return routeConfig;
}
